import EmblaCarousel from 'embla-carousel'
import { addPrevNextBtnsClickHandlers } from './slider-navigation'

const OPTIONS = {
  loop: true,
  align: 'center',
  breakpoints: {
    '(max-width: 768px)': { align: 'start' }
  }
}

const emblaNode = document.querySelector('.amp-slider')

if (emblaNode) {
  const viewportNode = emblaNode.querySelector('.amp-slider__viewport')
  const prevBtnNode = emblaNode.querySelector('.amp-slider__button--prev')
  const nextBtnNode = emblaNode.querySelector('.amp-slider__button--next')

  const emblaApi = EmblaCarousel(viewportNode, OPTIONS)

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
    emblaApi,
    prevBtnNode,
    nextBtnNode
  )

  emblaApi.on('destroy', removePrevNextBtnsClickHandlers)
}
